export default "__VITE_ASSET__BM1$4vju__"